// src/components/FbTimelineWidget.jsx
import React, { memo, useEffect, useMemo, useRef, useState } from "react";

const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

function FbTimelineWidget({ pageUrl = "", height = 700 }) {
    const wrapRef = useRef(null);
    const [w, setW] = useState(500);

    // ✅ ukur lebar container (safe + elak ResizeObserver loop warning)
    useEffect(() => {
        if (!wrapRef.current) return;

        let raf = 0;

        const measure = () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
                const cw = wrapRef.current?.clientWidth || 0;
                const next = clamp(Math.floor(cw), 180, 500);

                // ✅ penting: jangan set state kalau sama (elak loop warning)
                setW((prev) => (prev === next ? prev : next));
            });
        };

        // init
        measure();

        // ResizeObserver (guard untuk browser yang tak support)
        let ro = null;
        if (typeof window !== "undefined" && "ResizeObserver" in window) {
            ro = new ResizeObserver(measure);
            ro.observe(wrapRef.current);
        }

        // fallback orientation/resize
        window.addEventListener("resize", measure, { passive: true });

        return () => {
            cancelAnimationFrame(raf);
            if (ro) ro.disconnect();
            window.removeEventListener("resize", measure);
        };
    }, []);

    const url = useMemo(() => String(pageUrl || "").trim(), [pageUrl]);

    const src = useMemo(() => {
        if (!url) return "";
        const h = Number(height) || 700;

        return (
            "https://www.facebook.com/plugins/page.php?" +
            `href=${encodeURIComponent(url)}` +
            `&tabs=timeline` +
            `&width=${w}` +
            `&height=${h}` +
            `&small_header=false` +
            `&adapt_container_width=true` +
            `&hide_cover=false` +
            `&show_facepile=true`
        );
    }, [url, height, w]);

    if (!src) return null;

    return (
        <div ref={wrapRef} className="fb-embed fb-page fb-crop">
            <iframe
                key={src} // refresh iframe bila width berubah
                title="Facebook Page Timeline"
                src={src}
                loading="lazy"
                allow="encrypted-media; clipboard-write"
                // ✅ bagi dimension jelas (kurang glitch)
                style={{
                    width: "100%",
                    height: Number(height) || 700,
                    border: 0,
                    overflow: "hidden",
                    pointerEvents: "none", // ✅ disable scroll + interaction
                }}
                scrolling="no"
            />
            {/* extra blocker (optional, boleh buang kalau pointerEvents dah cukup) */}
            <div className="fb-blocker" aria-hidden="true" />
        </div>
    );
}

export default memo(FbTimelineWidget);
